import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { ToastAlertService } from 'src/app/shared/utils/toast.service';
import { RegisterModel, SignupCredentials, SingUpSendOtpResponse, SingUpVerifyOtpResponse } from '../domain';
import { ApiEndpointService } from './api-endpoint.service';
import md5 from 'md5';
import { httpFaultMessage } from 'src/app/shared/utils/http-fault.util';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {

  constructor(private http: HttpClient, private toastService: ToastAlertService) { }

  public sendOTP(signupCredentials: SignupCredentials): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.SIGN_UP_SEND_OTP);
    const params = {
      type: signupCredentials.type,
      countryCode: signupCredentials.countryCode,
      mobileNumber: signupCredentials.mobileNumber,
      emailAddress: signupCredentials.emailAddress,
      partnerId: signupCredentials?.partnerId
    };
    return this.http.post(url, params).pipe(
      map((response: SingUpSendOtpResponse) => {

        console.trace('============== sendOTP() response =============');

        return response.data
      }),
      catchError((fault: HttpErrorResponse) => {
        // SC-SAAS-FRONTEND-6S / SAN-470 -- httpFaultMessage covers the array and message shapes and, for an empty body
        // (504, network error), falls back to the status instead of logging "sendOTPFault( undefined )".
        console.warn(`sendOTPFault( ${httpFaultMessage(fault, `HTTP ${fault?.status}`)} )`);
        return throwError(() => fault);
      })
    );
  }

  public verifyOTP(signupCredentials: SignupCredentials): Observable<any> {
    if (!signupCredentials.code) {
      return throwError(() => ({ error: { message: 'Please enter the OTP code' } }));
    }
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.SIGN_UP_VERIFY_OTP);
    const params = {
      type: signupCredentials.type,
      countryCode: signupCredentials.countryCode,
      mobileNumber: signupCredentials.mobileNumber,
      emailAddress: signupCredentials.emailAddress,
      code: md5(signupCredentials.code.toString())
    };
    return this.http.post(url, params).pipe(
      map((response: SingUpVerifyOtpResponse) => {
        return response.data
      }),
      catchError((fault: HttpErrorResponse) => {
        // SAN-1039: a gateway timeout / network drop (0, 5xx — body is an
        // HTML error page, not JSON) used to show the generic "Error while
        // verifying OTP", reading like a wrong code. Tell the user it's a
        // server hiccup and that the same OTP can simply be retried.
        const isTransient = !fault?.status || fault.status >= 500;
        /* SC-SAAS-FRONTEND-FB -- the user is already toasted for a transient fault; don't also forward it
           to Sentry as a console.warn. Real client faults (4xx) still warn. */
        if (!isTransient) {
          console.warn(`verifyOTPFault( ${fault.error?.message || fault.message || fault.status} )`);
        }
        const message = isTransient
          ? 'The server is taking too long to respond. Please try again in a moment.'
          : (fault?.error?.message || 'Error while verifying OTP');
        this.toastService.showToast(message, 'error');
        return throwError(() => fault);
      })
    );
  }

  public registerUser(userData: RegisterModel): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.REGISTER);
    const params = userData;
    return this.http.post(url, params).pipe(
      map((response: any) => {
        return response.data
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`register( ${fault?.error?.message || fault?.message || fault?.status} )`);
        return throwError(() => fault);
      })
    );
  }


  public registerOtherUser(userData: RegisterModel,userType = 'other'): Observable<any> {
    const url = ApiEndpointService.getEndpoint(ApiEndpointService.ENDPOINT.REGISTER) + userType;
    const params = userData;
    return this.http.post(url, params).pipe(
      map((response: any) => {
        return response.data
      }),
      catchError((fault: HttpErrorResponse) => {
        console.warn(`register( ${fault?.error?.message || fault?.message || fault?.status} )`);
        return throwError(() => fault);
      })
    );
  }

}
